"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const ImageInfoKeys = Object.freeze({
    CAMERA_DATA: "THERMAL_IMAGER_INFO_DATA",
    THERMAL_IMAGE_INFO_DATA: "THERMAL_IMAGE_INFO_DATA",
    CALIBRATION_DATA: "CALIBRATION_DATA",
    VL_IMAGE_METADATA: "VL_IMAGE_METADATA",
    MARKERS: "MARKERS",
    PHOTONOTES: "IRPHOTONOTES",
    TEXTNOTES: "TEXTNOTES",
    IRVIEWER: "IRVIEWER",
    WIRELESS_FWCS: "WIRELESS_FWCS"
});
const _default = ImageInfoKeys;
